(function () {
	"use strict";

	angular.module("swurveys.common")
		.factory("currentSwurveyService", Handler);

	function Handler(utilsService, $routeParams, $route, swurveyService, preloaderService, liveReloadService, swurveysStageConfig, analyticsService, localStoreService) {

		var id = $routeParams.swurveyId || TEST_API;

		var cachedModelCards;
		var cachedModelOptions;

		var shortUrl;
		var state;

		var ownerId;
		var userId;

		function reloadStyles(stylesList) {
			var freeStyle = $("style#free-style")[0].sheet;

			utilsService.cleanUpStyle(freeStyle, false);
			stylesList.forEach(function (style) {
				var index = freeStyle.cssRules.length;
				try {
				  freeStyle.insertRule(style, index);

				}
				catch (e){
					console.warn(style);
					console.warn(e);
				}
			});
			var backgroundColor = $(".viewer").css("background-color");
			$('meta[name="theme-color"]').attr("content", backgroundColor);
		};

		function initLiveReload() {
			AWS.config.region = 'us-east-1';
			var credentials = new AWS.CognitoIdentityCredentials({
				IdentityPoolId: "us-east-1:b872b759-d2c9-4347-b8dc-ec18ec82af83"
			});
			credentials.get(function(err) {
				if(err) return console.log(err);

				var stage = swurveysStageConfig.getConfigPropertyValue("api_endpoint").split("/").pop();
				var topic = stage + "/users/" + userId + "/swurveys/" + id + "/model";
				liveReloadService.init(credentials, userId+new Date().getTime(), topic, function(msg) {
					var newModel = msg.payload;

					var newModelCards = JSON.stringify(newModel.cards);
					var newModelOptions = JSON.stringify(newModel.options);

					if (cachedModelCards !== newModelCards || cachedModelOptions !== newModelOptions) {
						$route.reload();
					}
					reloadStyles(newModel.styles);
				});
			});
		}

		function getCurrentModel(getModelSuccess, getModelError, getModelUpdate) {

			id = $routeParams.swurveyId;

			if(!id) return getModelError("NO_MODEL");

			swurveyService.getModel(id, function (err, resp) {
				if(err) {
					console.error(err);
					return getModelError(err.status);
				}

				var model = resp.data;

				if(!model) return getModelError("NO_MODEL");

				cachedModelCards = JSON.stringify(model.cards);
				cachedModelOptions = JSON.stringify(model.options);

				shortUrl = resp.headers("x-swv-short-url");
				state = resp.headers("x-swv-state");
				ownerId = resp.headers("x-swv-owner");
				userId = ownerId.substr(5);

				//Swurvey is closed or out of credits
				if(state == "Closed") {
				   $(".hide-when-loaded")
				    	.addClass("hide");
					return getModelUpdate({ id: 0, state: state });
				}

				getModelUpdate({
					id: 0,
					state: state,
					shortUrl: shortUrl,
					deckSize: model.cards.length
				});

				//Should we deny the Swurvey based upon cookies?
				if(state == "Published" && model.options && model.options.singleResponse && model.options.singleResponse.useCookie)
				{
					var key = "swv:" + getSwurveyId() + ":responseCount";
					var responseCount = localStoreService.getItem(key);
					if (responseCount > 0) {
						//Just bail out now
						$(".hide-when-loaded")
							.addClass("hide");
						return getModelUpdate({ id: 0, state: "AlreadyResponded" });
					}
				}

				// Loads in styles
				reloadStyles(model.styles);

				utilsService.applyStyleOverrides(model);

				var priorityAssets = [];
				var secondaryAssets = [];

				// Check cards for images
				model.cards.forEach(function (card, index) {
					if(card.img) {
						if (index === 0) {
							priorityAssets.push(card.img);
						} else {
							secondaryAssets.push(card.img);
						}
					}
				});

				// Check css styles for images
				model.styles.forEach(function (style) {
					var backgroundImgRegex = new RegExp('^\.viewer');
					var imgLinkRegex = new RegExp('(https://app(-(alpha|preprod))?\.swurveys\.com/[a-zA-Z0-9-:/\.]*)', 'ig');
					var match = style.match(imgLinkRegex);
					if (match) {
						if (style.match(backgroundImgRegex)) {
							priorityAssets.push(match[0]);
						} else {
							secondaryAssets.push(match[0]);
						}
					}
				});

				analyticsService.mark("PreloadImagesStart");
				// Stage 2 notify image here
				preloaderService.preloadImages(priorityAssets)
					.then(function resolved() {
						analyticsService.mark("PreloadImagesPriorityFinished");
						getModelSuccess(model);
					})
					.catch(function(img) {
						//If an image does not exist, we still want to start the Swurvey..but we also want to track that this occurred
						analyticsService.trackEvent('ImageFailedToLoad', id);
						getModelSuccess(model);
					});

				preloaderService.preloadImages(secondaryAssets)
				   .then(function () {
					   analyticsService.mark("PreloadImagesSecondaryFinished");
				   })
					.catch(function(img) {
						analyticsService.trackEvent('ImageFailedToLoad', id);
					});

				if(state == "New") {
					initLiveReload();
		    }
			});
		};

		function getSwurveyState() {
			return state;
		};

		function getSwurveyShortURL() {
			return shortUrl;
		};

		function getSwurveyId() {
			return id;
		}

		function getSwurveyOwnerId() {
			return ownerId;
		};

		return {
			getSwurveyId: getSwurveyId,
			getCurrentModel: getCurrentModel,
			getSwurveyState: getSwurveyState,
 			getSwurveyShortURL: getSwurveyShortURL,
 			getSwurveyOwnerId : getSwurveyOwnerId
		}

	}
}());
